module.exports = __webpack_public_path__ + "media/images/icon__live-2eab4b4e4467df4448a79e5a5010c523.png";